import { useLocation } from "react-router-dom";

export const useSingleAdClassSearchExperiment = () => {
  const location = useLocation();

  const activityUid = location.query?.activityUid;
  const searchFilterQ = location.query?.q;

  // const { experimentAssignments } = useServerExperimentContext();
  // const variant = experimentAssignments["SingleAdClassSearch2"];
  // SSR variant is not the same as the client variant,
  // here only used params to check is treatment or not.
  // since this is unique params, is relatively safe
  // need to investigate more to get the correct experiment variant.

  // trigger experiment in CF worker.
  return {
    isSingleAdClassTreatment: searchFilterQ && activityUid,
    activityUid,
  };
};
